/* @flow */

import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import useLiveChatActions from 'plugin/live-chat/hook/useLiveChatActions';
import useLiveChat from 'plugin/live-chat/hook/useLiveChat';
import useMembership from 'src/shared/domain/membership/hook/useMembership';
import useSelf from 'src/shared/domain/user/hook/useSelf';
import useDidUpdateEffect from 'src/shared/app/base/hook/useDidUpdateEffect';

export function hideLiveChatWidget() {
  window.Tawk_API.endChat();
  window.Tawk_API.hideWidget();
}

export default function useLiveChatVisitorAuth() {
  const token = useSelector(getAuthenticationToken);
  const hasLiveChat = useLiveChat();
  const { load, kill, identify, update } = useLiveChatActions();

  const membership = useMembership();
  const selfUser = useSelf();

  const isIdentified = React.useRef(false);

  React.useEffect(() => {
    if (hasLiveChat) {
      load();
    } else {
      kill();
    }
  }, [token, hasLiveChat]);

  const location = useLocation();

  useDidUpdateEffect(() => {
    update();
  }, [location]);

  useDidUpdateEffect(() => {
    if (hasLiveChat && membership && selfUser && !isIdentified.current) {
      identify();
      isIdentified.current = true;
    }
  }, [membership, selfUser, hasLiveChat]);
}
